import React from "react";

const Video = (props) => {

    return <div className={props.active}>
            <iframe className="player" type="text/html" width="100%" height="100%" title={props.videoId}
                src={"https://www.youtube.com/embed/" +
                props.videoId + "?autoplay=1&rel=0&modestbranding=1"}
                frameBorder="0"/>
            </div>;

};

export default Video


// WEBPACK FOOTER //
// ./src/components/elements/modals/Video.js